var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditCardIcon = function SvgCreditCardIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M28 3c.55 0 1 .45 1 1v2H3V4c0-.55.45-1 1-1zm1 7v10c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V10zM4 0C1.794 0 0 1.794 0 4v16c0 2.206 1.794 4 4 4h24c2.206 0 4-1.794 4-4V4c0-2.206-1.794-4-4-4zm1 17.5c0 .831.669 1.5 1.5 1.5h3c.831 0 1.5-.669 1.5-1.5S10.331 16 9.5 16h-3c-.831 0-1.5.669-1.5 1.5m9 0c0 .831.669 1.5 1.5 1.5h4c.831 0 1.5-.669 1.5-1.5s-.669-1.5-1.5-1.5h-4c-.831 0-1.5.669-1.5 1.5"
  })));
};
export default SvgCreditCardIcon;